export default __webpack_public_path__ + "static/media/retail1.19ea37d7.svg";